



















import Vue from 'vue';
import Scheduled from '../components/Scheduled.vue';
import FailedIds from '../components/FailedIds.vue';
import { useScheduled, useMessages } from '../hooks';

export default Vue.extend({
  components: { Scheduled, FailedIds },
  setup() {
    const { scheduled } = useScheduled('assessments');
    const { messages } = useMessages('assessments');

    return {
      scheduled,
      messages,
    };
  },
});
